import { getDecimalPlaces } from "../components/Shared/Utility";

/**
 * PDF number format using pump DecimalPlaces setting.
 * Optional second arg ignored for consistency with NumberFormat.
 */
export const PrintFormateNumber = (num, _decimalsIgnored) => {
  if (num === null || num === undefined || isNaN(num)) return "0";

  const decimals = getDecimalPlaces();
  const fixedNum = Number(num).toFixed(decimals);

  return fixedNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
